import React from 'react'
import { GridWrapper, Logo, ErrorTypography } from './SuppliersNoInfo.styles'

const SuppliersNoInfo = () => {
  return (
    <GridWrapper container className="error__container">
      <Logo src="/assets/images/logo-dccp.svg" />
      <ErrorTypography variant="h4" color="black1" fontWeight="bold" className="error__title">
        No existe información
      </ErrorTypography>
      <ErrorTypography variant="body1" color="black1" className="error__description">
        El organismo comprador no cuenta con información relacionada a sus proveedores más transados durante el año
        seleccionado.
      </ErrorTypography>
    </GridWrapper>
  )
}

export default SuppliersNoInfo
